import { useRouteError } from 'react-router-dom'
import { ErrorPage } from './ErrorPage'
import { RemoteRouteObserver } from '@wellesley/host-remote/remote/components/RemoteRouteObserver'

export const RouterErrorPage = () => {
  const error = useRouteError()
  return (
    <>
      <RemoteRouteObserver />
      <ErrorPage error={error} />
    </>
  )
}
